<div class="flex flex-col items-center justify-center py-20">
	<span class="animate-pulse text-2xl text-gold">☩</span>
	<p class="mt-4 text-sm text-navy-muted">Loading...</p>
</div>
